import React, { useState } from "react";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  fallbackSrc?: string;
  loadingComponent?: React.ReactNode;
  errorComponent?: React.ReactNode;
  isExternal?: boolean;
}

export const Image: React.FC<ImageProps> = ({ src, alt, fallbackSrc, loadingComponent, errorComponent, isExternal = false, ...props }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  if (isLoading && loadingComponent) {
    return <>{loadingComponent}</>;
  }

  if (hasError && errorComponent) {
    return <>{errorComponent}</>;
  }

  return <img src={hasError && fallbackSrc ? fallbackSrc : src} alt={alt} onLoad={handleLoad} onError={handleError} loading="lazy" {...props} />;
};

interface IconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
}

export const Icon = React.forwardRef<HTMLImageElement, IconProps>(({ className, src, alt, ...props }, ref) => {
  return <img ref={ref} src={src} alt={alt} className={className} {...props} />;
});

Icon.displayName = "Icon";

export default Icon;
